import * as i0 from "@angular/core";
export class KYCVerificationService {
    constructor() { }
}
KYCVerificationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function KYCVerificationService_Factory() { return new KYCVerificationService(); }, token: KYCVerificationService, providedIn: "root" });
